module.exports = __webpack_public_path__ + "img/add-icon-white.82b5f06b.svg";